import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LocalStorageKeys } from '../models/local-storage.model';
import { retry, catchError } from 'rxjs/operators';
import { ErrorMessages } from '../models/message.model';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Statement } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router, private toastrService: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (!(error.error instanceof ErrorEvent)) {
                    if (error.error && (error.error.message === ErrorMessages.InvalidToken)) {
                        localStorage.removeItem(LocalStorageKeys.Token);
                        localStorage.removeItem(LocalStorageKeys.User);
                        this.toastrService.error('Sesja wygasła');
                        this.router.navigate(['/login']);
                    }
                    else if (error.error && (error.error.message === ErrorMessages.InvalidCredentials)) {
                        localStorage.removeItem(LocalStorageKeys.Token);
                        localStorage.removeItem(LocalStorageKeys.User);
                        this.toastrService.error('Wprowadziłeś nieprawidłowe dane do logowania');
                        this.router.navigate(['/login']);
                    }
                    else if (error.error && (error.error.message === ErrorMessages.TwoFactorRequired)) {
                        localStorage.removeItem(LocalStorageKeys.Token);
                        localStorage.removeItem(LocalStorageKeys.User);
                        this.toastrService.error('Wymagane jest skonfigurowanie uwierzytelniania dwuskładnikowego. Zaloguj się ponownie.');
                        this.router.navigate(['/login']);
                    }
                    else if (error.error && (error.error.message === ErrorMessages.AccountNotActive)) {
                        localStorage.removeItem(LocalStorageKeys.Token);
                        localStorage.removeItem(LocalStorageKeys.User);
                        this.toastrService.error('Podane konto jest nieaktywne');
                        this.router.navigate(['/login']);
                    }
                    else if (error.status === 404) {
                        this.router.navigate(['/404']);
                    }
                    else if (error.status === 403) {
                        this.router.navigate(['/403']);
                    }
                }
                return throwError(error);
            })
        )
    }
}